import { useEffect, useState } from "react"
import { useWindowDimensions } from "~/utils/useWindowDimensions"
import { gridConfig } from "~/utils/gridConfig"
import { useQueryString } from "~/hooks/useQueryString"

const DEFAULT_LAYOUT = 4

export function useGrid() {
  const [queryString, setQueryString] = useQueryString({ layout: 4 })

  let initialLayout = DEFAULT_LAYOUT

  if (queryString?.layout) {
    if (Object.keys(gridConfig).includes(queryString.layout.toString())) {
      initialLayout = queryString.layout
    } else {
      const { layout: _, ...restOfQuery } = queryString
      setQueryString({ ...restOfQuery })
    }
  }

  const [layout, setLayout] = useState(initialLayout)
  const { width, breakpoint } = useWindowDimensions()
  const [dimensions, setDimensions] = useState(getDimensions(width, layout))
  const [controlsEnabled, setControlsEnabled] = useState(false)

  useEffect(() => {
    setDimensions(getDimensions(width, layout))
  }, [width, layout])

  return {
    gridConfig: gridConfig[layout],
    layout,
    setLayout,
    dimensions,
    breakpoint,
    queryString,
    setQueryString,
    controlsEnabled,
    setControlsEnabled,
  }
}

function getDimensions(width, layout) {
  const columns = gridConfig[layout].numCols

  const videoWidth = width / columns
  const singleWidth = width
  const largeWidth = videoWidth * 2
  const focusWidth = width - 288

  return {
    single: { width: singleWidth, height: singleWidth * (9 / 16) },
    normal: { width: videoWidth, height: videoWidth * (9 / 16) },
    large: { width: largeWidth, height: largeWidth * (9 / 16) },
    focus: { width: focusWidth, height: focusWidth * (9 / 16) },
    frame: {
      single: { width: singleWidth, height: singleWidth * (9 / 16) },
      normal: {
        width: videoWidth,
        height: videoWidth * (9 / 16),
      },
      large: {
        width: largeWidth,
        height: largeWidth * (9 / 16),
      },
      focus: {
        width: focusWidth,
        height: focusWidth * (9 / 16),
      },
    },
  }
}
